import NguyenVongMixins from '@/mixins/nguyenvong.mixins'
export default {
	props: {
		loaiDot: {
			type: String,
			default: "HOCBA"
		},
	},
	mixins: [NguyenVongMixins],
	data() {
		return {
			coSoId: "",
			nganhByCoSoes: [],
		}
	},
	methods: {
		getNganhByCoSo(id) {
			this.updateCoSoId({
				index: this.stt,
				id: id,
			});
			this.nganhByCoSoes = [...this.nganhs.filter(item => item.coSoId == id)];
			let check = this.nganhByCoSoes.find(item => item.nganhId == this.nguyenvong.nganhId);
			if (!check) {
				this.nguyenvong.nganhId = null;
				this.nguyenvong.toHopId = null;
			}
			this.coSoId = id;
		},
		getCoSoIdByNganhId(id) {
			let nganh = this.nganhs.find(item => item.nganhId == id);
			this.nguyenvong.coSoId = nganh ? nganh.coSoId : 0;
			this.getNganhByCoSo(nganh.coSoId)
		}
	},
	async created() {
		this.updateIsLoadDelete(true);
		await this.layThongTinNguyenVong(this.stt).then((data) => {
			if (data.coSoId) this.getNganhByCoSo(data.coSoId);
			this.nguyenvong = { ...data };
		});
		if (this.nganhId) {
			await this.getNganhTopHop(this.nganhId);
			await this.getCoSoIdByNganhId(this.nganhId)
		}
	},
	watch: {
		coSoId(value) {
			this.getNganhByCoSo(value);
		}
	},
};
